// Copyright (C) 2017-2023 Smart code 203358507

const VolumeChangeIndicator = require('./VolumeChangeIndicator');

module.exports = VolumeChangeIndicator;
